var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.15385 5.30774C2.58261 5.30774 2.03477 5.53466 1.63085 5.93859C1.22692 6.34251 1 6.89035 1 7.46159V26.8462C1 27.4174 1.22692 27.9653 1.63085 28.3692C2.03477 28.7731 2.58261 29 3.15385 29H26.8462C27.4174 29 27.9652 28.7731 28.3692 28.3692C28.7731 27.9653 29 27.4174 29 26.8462V7.46159C29 6.89035 28.7731 6.34251 28.3692 5.93859C27.9652 5.53466 27.4174 5.30774 26.8462 5.30774H22.5385",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46143 1V9.61538",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5386 1V9.61538",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46143 5.30774H18.2307",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46169 17.1538C8.05646 17.1538 8.53861 16.6717 8.53861 16.0769C8.53861 15.4822 8.05646 15 7.46169 15C6.86692 15 6.38477 15.4822 6.38477 16.0769C6.38477 16.6717 6.86692 17.1538 7.46169 17.1538Z",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 17.1538C15.5945 17.1538 16.0767 16.6717 16.0767 16.0769C16.0767 15.4822 15.5945 15 14.9998 15C14.405 15 13.9229 15.4822 13.9229 16.0769C13.9229 16.6717 14.405 17.1538 14.9998 17.1538Z",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5388 17.1538C23.1336 17.1538 23.6158 16.6717 23.6158 16.0769C23.6158 15.4822 23.1336 15 22.5388 15C21.9441 15 21.4619 15.4822 21.4619 16.0769C21.4619 16.6717 21.9441 17.1538 22.5388 17.1538Z",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46169 23.6154C8.05646 23.6154 8.53861 23.1332 8.53861 22.5385C8.53861 21.9437 8.05646 21.4615 7.46169 21.4615C6.86692 21.4615 6.38477 21.9437 6.38477 22.5385C6.38477 23.1332 6.86692 23.6154 7.46169 23.6154Z",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalIcon);
export default __webpack_public_path__ + "static/media/cal_icon.0daaccf433c225e7e69fe19f37aaaba8.svg";
export { ForwardRef as ReactComponent };